/**
 * Redirection plein page (hors React Router).
 * Isolée ici pour rester mockable dans les tests.
 */
export function redirectTo(url: string): void {
  window.location.assign(url)
}
